/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUnitTypeRequest
 */
export interface CreateUnitTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUnitTypeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitTypeRequest
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitTypeRequest
     */
    color?: string;
}

/**
 * Check if a given object implements the CreateUnitTypeRequest interface.
 */
export function instanceOfCreateUnitTypeRequest(value: object): value is CreateUnitTypeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateUnitTypeRequestFromJSON(json: any): CreateUnitTypeRequest {
    return CreateUnitTypeRequestFromJSONTyped(json, false);
}

export function CreateUnitTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUnitTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateUnitTypeRequestToJSON(json: any): CreateUnitTypeRequest {
    return CreateUnitTypeRequestToJSONTyped(json, false);
}

export function CreateUnitTypeRequestToJSONTyped(value?: CreateUnitTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'icon': value['icon'],
        'color': value['color'],
    };
}

